import _classCallCheck from "/Users/john_richardson/mapping-impactful-media/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/john_richardson/mapping-impactful-media/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/john_richardson/mapping-impactful-media/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/john_richardson/mapping-impactful-media/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/john_richardson/mapping-impactful-media/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { BaseGradientBackground } from "../base/BaseGradientBackground";
/**
 * @description Specifies that the gradient fade effect, used for the background when resizing with padding, uses the
 * predominant colors in the border pixels of the image.
 * @memberOf Qualifiers.Background
 * @extends {Qualifiers.Background.BaseGradientBackground}
 */

var BackgroundBorderGradientQualifier = /*#__PURE__*/function (_BaseGradientBackgrou) {
  _inherits(BackgroundBorderGradientQualifier, _BaseGradientBackgrou);

  var _super = _createSuper(BackgroundBorderGradientQualifier);

  function BackgroundBorderGradientQualifier() {
    _classCallCheck(this, BackgroundBorderGradientQualifier);

    return _super.apply(this, arguments);
  }

  _createClass(BackgroundBorderGradientQualifier, [{
    key: "toString",
    value:
    /**
     * @description
     * Stringify the qualifier
     * BackgroundQualifiers don't have a value, but instead override the toString() function.
     */
    function toString() {
      return "\n    b_auto:border_gradient\n    ".concat(this._constrast ? '_contrast' : '', "\n    ").concat(this._gradientColors ? ":".concat(this._gradientColors) : '', "\n    ").concat(this._gradientDirection ? ":".concat(this._gradientDirection) : '', "\n    ").concat(this._palette.length ? ":palette_".concat(this._palette.join('_')) : '', "\n    ").replace(/\s+/g, '');
    }
  }]);

  return BackgroundBorderGradientQualifier;
}(BaseGradientBackground);

export { BackgroundBorderGradientQualifier };